Vendd.Scripts.load(function () {

    var $wrapper = $('.x-menu.main-menu');
    var openClass = 'x-open';

    if ($wrapper.length < 1) return;

    initDesktopMenu();
    if (isTouch()) initMobileMenu();

    $(window).resize(function () {
        if (isTouch() && $(window).outerWidth() < 1200) {
            initMenuHeight();  
        } else {
            closeMenu();  
        }
    });

    function initDesktopMenu() {      
        initMenuTriggers();
        initTwoLevelMenu();
        initThreeLevelMenu();
    }

    function initTwoLevelMenu() {

        var $submenus = $('.nav-link-1', $wrapper);

        if ($submenus.length < 1) return;

        //if isTouch menu actions on click
        //else menu actions on hover
        if (isTouch()) {

            $submenus.click(function () {

                var $el = $(this);

                if ($(window).outerWidth() < 1200) {
                    var $nav2 = $el.siblings('.nav-2');
                    $nav2.css('display', 'block');

                    requestAnimationFrame(() => {
                        $nav2.addClass('mobile-revealed');
                    });
                    $('.off-canvas-menu').addClass('is-menu-opened');

                } else {
                    $el = $(this).closest('li.nav-item-1');
                    $('.nav-1', $wrapper).removeClass('opened-nav-3');

                    if ($el.find('.nav-2').length > 0) {
                        $el.closest('.nav-1').addClass('opened-nav-2');
                    } else {
                        $el.closest('.nav-1').removeClass('opened-nav-2');
                    }

                    $el.addClass('hovered');
                    $el.children('.nav-2').addClass('revealed');
                    $el.closest('.nav-1').find('.nav-2 > .nav-box > ul > li').removeClass("hovered").find('.nav-3').removeClass('revealed');
                    $el.siblings().removeClass('hovered').find('.nav-2').removeClass('revealed');

                    if ($el.find('.nav-2 li.hovered').length > 0) {
                        if ($el.find('.nav-2 li.hovered').find('.nav-3').length > 0) {
                            $('.nav-1', $wrapper).addClass('opened-nav-3');
                        }
                    }
                }
            });

        } else {
            //hoverIntent configurations
            var config = {
                sensitivity: 50,
                interval: 60,
                over: mouseenter,
                timeout: 10,
                out: mouseleave
            };

            function mouseenter() {
                var $el = $(this);

                $('.nav-1', $wrapper).removeClass('opened-nav-3');

                if ($el.find('.nav-2').length > 0) {
                    $el.closest('.nav-1').addClass('opened-nav-2');
                } else {
                    $el.closest('.nav-1').removeClass('opened-nav-2');
                }

                $el.addClass('hovered');
                $el.children('.nav-2').addClass('revealed');
                $el.closest('.nav-1').find('.nav-2 > .nav-box > ul > li').removeClass("hovered").find('.nav-3').removeClass('revealed');
                $el.siblings().removeClass('hovered').find('.nav-2').removeClass('revealed');

                if ($el.find('.nav-2 li.hovered').length > 0) {
                    if ($el.find('.nav-2 li.hovered').find('.nav-3').length > 0) {
                        $('.nav-1', $wrapper).addClass('opened-nav-3');
                    }
                }
            }

            function mouseleave() {
                return;
            }

            $submenus.parent().hoverIntent(config);
        }

    }

    function initThreeLevelMenu() {

        var $submenuItems = $('.nav-2 .nav-item-2 .nav-link-2', $wrapper);
        
        if ($submenuItems.length < 1) return;

        //if isTouch menu actions on click
        //else menu actions on hover
        if (isTouch()) {

            $submenuItems.click(function () {

                var $el = $(this);

                if ($(window).outerWidth() < 1200) {
                    var $nav3 = $el.siblings('.nav-3');
                    $nav3.css('display', 'block');

                    requestAnimationFrame(() => {
                        $nav3.addClass('mobile-revealed');
                    });

                } else {
                    var $parentLi = $el.closest('li.nav-item-2');

                    if ($parentLi.find('.nav-3').length > 0) {
                        $parentLi.closest('.nav-1').addClass('opened-nav-3');
                    } else {
                        $parentLi.closest('.nav-1').removeClass('opened-nav-3');
                    }

                    $parentLi.siblings().removeClass('hovered').find('.nav-3').removeClass('revealed');
                    $parentLi.addClass('hovered');
                    $parentLi.children('.nav-3').addClass('revealed');
                }

            });

        } else {

            //hoverIntent configurations
            var config = {
                sensitivity: 50,
                interval: 30,
                over: mouseenter,
                timeout: 0,
                out: mouseleave
            };

            function mouseenter() {
                var $parentLi = $(this).closest('li');

                if ($parentLi.find('.nav-3').length > 0) {
                    $parentLi.closest('.nav-1').addClass('opened-nav-3');
                } else {
                    $parentLi.closest('.nav-1').removeClass('opened-nav-3');
                }

                $parentLi.siblings().removeClass('hovered').find('.nav-3').removeClass('revealed');
                $parentLi.addClass('hovered');
                $parentLi.children('.nav-3').addClass('revealed');
            }

            function mouseleave() {
                return;
            }

            $submenuItems.hoverIntent(config);
        }
    }

    function initMenuTriggers() {

        var $trigger = $('.js-menu-trigger', $wrapper);

        $trigger.on('click', function () {

            if ($('.main-menu').hasClass(openClass)) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        $('.menu-overlay').on('click', function () {
            closeMenu();
        });
    }

    function calculateMenuHeight() {
        var header = $('.header-region');
        var mainMenu = $('.main-menu', header);

        var headerHeight, uselessHeight, eSatisfactionHeight, menuOffset;

        headerHeight = $('.header-region').height() || 0;
        uselessHeight = $('.header-region .region-area-four').height() || 0;
        eSatisfactionHeight = $('.esat-bar').height() || 0;

        menuOffset = headerHeight + eSatisfactionHeight - uselessHeight;

        $('.nav-1, .nav-2, .nav-3', mainMenu).css({ 'height': 'calc(100% - ' + menuOffset + 'px)', top: menuOffset });
    }

    function openMenu() {

        if ($wrapper.hasClass(openClass)) return;

        $('html, body').addClass('no-scroll');
        $('.header-region').removeClass('sticky');
        $('.header-spacer').css('height', 0);
        $('.menu-overlay').addClass('mega-menu-visible');
        $('.main-menu').addClass(openClass);
        calculateMenuHeight();
        setInterval(function () { calculateMenuHeight(); }, 1000);
    }

    function closeMenu() {

        if (!$wrapper.hasClass(openClass)) return;

        $wrapper.removeClass(openClass);
        $('.nav-1', $wrapper).removeClass('opened-nav-2').removeClass('opened-nav-3');
        $('.nav-2', $wrapper).removeClass('opened-nav-3');
        $('.hovered', $wrapper).removeClass('hovered');
        $('.revealed', $wrapper).removeClass('revealed');
        $('.menu-overlay').removeClass('mega-menu-visible');
        $('html, body').removeClass('no-scroll');

    }

    function initMobileMenu() {

        //off canvas buttons
        var $openOffCanvas = $('.header-region .js-mobile-btn');
        var $closeOffCanvas = $('.off-canvas-menu .js-close-canvas');
        //main menu buttons
        var $backMenu = $('.mobile-show-prev', $wrapper);
        var $closeMenu = $('.mobile-show-close', $wrapper);

        //open off canvas menu
        $openOffCanvas.on('click', function (e) {
            openOffCanvasMenu();
        });

        //close off canvas menu
        $closeOffCanvas.on('click', function (e) {
            closeOffCanvasMenu();
        });

        //back to previous menu level
        $backMenu.on('click', function (e) {
            var $this = $(this);

            if ($this.hasClass('prev-2')) {
                $this.closest('.nav-2').removeClass('mobile-revealed');
                $this.closest('.nav-2').one('transitionend', function (e) {
                    if (e.originalEvent.propertyName !== 'left') return;
                    $(this).css('display', 'none');
                });
                $this.closest('.nav-1').scrollTop(0);
                $('.off-canvas-menu').removeClass('is-menu-opened');
            } else if ($this.hasClass('prev-3')) {
                $this.closest('.nav-3').removeClass('mobile-revealed');
                $this.closest('.nav-3').one('transitionend', function (e) {
                    if (e.originalEvent.propertyName !== 'left') return;
                    $(this).css('display', 'none');
                });
                $this.closest('.nav-2').scrollTop(0);
            }
        });


        //close opened menu levels
        $closeMenu.on('click', function (e) {
            var $this = $(this);

            $this.closest('.nav-3').removeClass('mobile-revealed');
            $this.closest('.nav-2').removeClass('mobile-revealed');

            $this.closest('.nav-3').one('transitionend', function (e) {
                if (e.originalEvent.propertyName !== 'left') return;
                $(this).css('display', 'none');
            });

            $this.closest('.nav-2').one('transitionend', function (e) {
                if (e.originalEvent.propertyName !== 'left') return;
                $(this).css('display', 'none');
            });

            $('.off-canvas-menu').removeClass('is-menu-opened');
        });

        $('.site-overlay').on('click', function (e) {
            //reset main menu
            if ($('.off-canvas-menu').hasClass('is-menu-opened')) {
                resetMainMenu();
            }
            //close off canvas
            if ($('html').hasClass('show-canvas')) {
                setTimeout(function () {
                    closeOffCanvasMenu();
                }, 200);
            }
        });

        $(window).resize($.debounce(100, function () {
            if ($(window).outerWidth() > 1199) {
                //reset main menu
                if ($('.off-canvas-menu').hasClass('is-menu-opened')) {
                    resetMainMenu();
                }
                //close off canvas
                if ($('html').hasClass('show-canvas')) {
                    closeOffCanvasMenu();
                }
            }   
        }));

        function openOffCanvasMenu() {
            $("html").addClass("show-canvas no-scroll");

            if ($('.header-region').hasClass('sticky')) {
                $('.header-spacer').height(0);
                $('.header-region').removeClass('sticky');
            }

            setTimeout(function () {
                $('.site-overlay').fadeIn(300);
            }, 300);
        }

        function closeOffCanvasMenu() {
            $('html').removeClass('show-canvas no-scroll');
            $('.site-overlay').hide();
        }

        function resetMainMenu() {
            $('.nav-3', $wrapper).removeClass('mobile-revealed');
            $('.nav-2', $wrapper).removeClass('mobile-revealed');

            $('.nav-3', $wrapper).one('transitionend', function (e) {
                if (e.originalEvent.propertyName !== 'left') return;
                $(this).css('display', 'none');
            });

            $('.nav-2', $wrapper).one('transitionend', function (e) {
                if (e.originalEvent.propertyName !== 'left') return;
                $(this).css('display', 'none');
            });

            $('.off-canvas-menu').removeClass('is-menu-opened');
        }
    }

    function initMenuHeight() {

        var $menu = $('.x-menu.main-menu');
        var $nav1 = $('.nav-1', $menu);
        var $nav2 = $('.nav-2', $menu);
        var $nav3 = $('.nav-3', $menu);

        if ($nav1.length > 0) $nav1.removeAttr('style');
        if ($nav2.length > 0) $nav2.removeAttr('style');
        if ($nav3.length > 0) $nav3.removeAttr('style');
    }

});




